import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import CardDeals from '../components/CardDeals';
import './Deals.css';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import PageTransition from '../components/PageTransition';

const Deals = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const q = query(
      collection(db, 'deals'),
      where('published', '==', true),
      orderBy('order', 'asc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      try {
        const dealsData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setDeals(dealsData);
        setError(null);
        setLoading(false);
      } catch (err) {
        console.error("Erreur lors de la récupération des deals:", err);
        setError(err);
        setLoading(false);
      }
    }, (error) => {
      console.error("Erreur listener Firestore:", error);
      setError(error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Une erreur est survenue...</div>;

  return (
    <div className="deals-page">
      <CardDeals deals={deals} />
    </div>
  );
};

export default Deals; 